import {Button, Modal} from "react-bootstrap";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";
import {formatDate, interventionDate} from "../../../utils/date";

const validationSchema = Yup.object({
  from: Yup.date().required("Date début est requise"),
  to: Yup.date()
    .required("Date fin est requise")
    .min(Yup.ref("from"), "Date fin doit être après la date début"),
});

const DateModal = ({open, setOpen, type, dispatch, initialDate}) => {
  // Initial date logging
  const handleSubmit = (values) => {
    const actionType =
      type === "intervention"
        ? "Nombre d'interventions"
        : type === "review"
          ? "Nombre de reviews"
          : "";

    if (actionType) {
      dispatch({
        type: actionType,
        payload: {
          from: formatDate(new Date(values.from), "YYYY-MM-DD"),
          to: formatDate(new Date(values.to), "YYYY-MM-DD"),
        },
      });
    }

    setOpen(false);
  };

  return (
    <Modal
      className="modal fade"
      show={open}
      onHide={() => setOpen(false)}
      centered
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => setOpen(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className="flex flex-col gap-2 justify-center items-center !px-12">
            <Formik
              initialValues={{
                from: !!initialDate?.from
                  ? new Date(initialDate?.from).toISOString().split("T")[0]
                  : "",
                to: !!initialDate?.to
                  ? new Date(initialDate?.to).toISOString().split("T")[0]
                  : "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form className="w-full flex flex-col gap-3">
                  <div className="flex flex-col">
                    <label htmlFor="from" className="text-sm font-medium">
                      Date Début
                    </label>
                    <Field
                      name="from"
                      type="date"
                      className="border border-gray-300 rounded-md p-2"
                    />
                    <ErrorMessage
                      name="from"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="to" className="text-sm font-medium">
                      Date Fin
                    </label>
                    <Field
                      name="to"
                      type="date"
                      className="border border-gray-300 rounded-md p-2"
                    />
                    <ErrorMessage
                      name="to"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row gap-4 items-center w-full !mt-4 mb-3">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="!rounded-md flex-1 w-full bg-white !py-3 text-[#1A64B9] !border !border-[#1A64B9] font-medium text-sm"
                    >
                      Annuler
                    </button>
                    <button
                      type="submit"
                      className="!rounded-md flex-1 w-full !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm"
                    >
                      Confirmer
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DateModal;
